import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './FieldsetTitle.scss';

function FieldsetTitle({ className, children }) {
  return <legend className={classNames('fieldset-title', className)}>{children}</legend>;
}

FieldsetTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FieldsetTitle;
